module.exports = __webpack_public_path__ + "static/lounge-7dceeaaf41cfd43617b6a942b1f86823.jpg";